export const clearOnType = (form = {}, type) => {


    const clearKilometraze = (form) => {
        if (form?.drogi_list?.length) {
            form?.drogi_list?.forEach(droga => {
                    if (droga?.miejscowosci_list?.length > 1 && droga?.kilometraze_list?.length > 1) {
                        droga?.miejscowosci_list?.forEach(miejscowosc => {
                            delete miejscowosc?.kilometraze_list;
                        });
                    }
                }
            )
        }

    }

    const clearPodmiotTyp = (form) => {
        if (form?.podmioty_list?.length > 1) {
            form?.podmioty_list?.forEach(podmiot => {
                if (podmiot?.['typ']) delete podmiot?.['typ']
            })
        }
    }

    const clearSprawyPowiazane = (form) => {
        if (form.czy_sprawy_powiazane === 'Nie') delete form['sprawy_powiazane_list']
    }

    const clearDrogi = (form) => {
        if (form?.czy_cala_siec === 'Tak') delete form['drogi_list']
    }


    if (type === 'Czasowa') {
        clearSprawyPowiazane(form)
    }

    if (type !== 'Uproszczona') {
        delete form['czy_cala_siec']
    }

    if (type === 'Stała' && form['data_przywrocenia']) {
        delete form['data_przywrocenia']
    }
    if (type !== 'Opinia') {
        delete form['czy_opinia_do_geometrii']
    }

    if (type === 'Uproszczona' || type === 'Opinia' || type === 'Awaryjna') {
        clearKilometraze(form)
        clearPodmiotTyp(form)
        clearSprawyPowiazane(form)
        clearDrogi(form)
        delete form['data_przywrocenia']
        delete form['data_wprowadzenia']
    }

    return form
}